export default (() => {
  const enableLabelAnimation = (settings) => {
    const { elements, field, fieldActive } = {
      elements: ".form .input",
      field: ".field",
      fieldActive: "field--filled",
      ...settings,
    };

    function detectIfValueIsEmpty() {
      var elm = this.closest(field);
      this.value
        ? elm.classList.add(fieldActive)
        : elm.classList.remove(fieldActive);
    }

    function detectIfExists() {
      var elm = this.closest(field);
      this ? elm.classList.add(fieldActive) : elm.classList.remove(fieldActive);
    }

    const elementsInDom = document.querySelectorAll(elements);
    Array.from(elementsInDom).forEach((element) => {
      ["input", "focus"].forEach((evt) =>
        element.addEventListener(evt, detectIfExists, false)
      );

      ["blur"].forEach((evt) =>
        element.addEventListener(evt, detectIfValueIsEmpty, false)
      );
    });
  };

  return {
    enableLabelAnimation: enableLabelAnimation,
  };
})();
